// extracted by mini-css-extract-plugin
module.exports = {"PdfImg":"KaiPiao_PdfImg__36UMC"};